import React, { createContext, useContext } from 'react';

const LocaleContext = createContext({ locale: 'en-GB', t: (key) => key });

// Import all locale strings at build time
const allStrings = {};

function importAll(r) {
  r.keys().forEach(key => {
    // key looks like ./en-GB.json, ./de-DE.json, etc.
    const locale = key.replace('./', '').replace('.json', '');
    allStrings[locale] = r(key);
  });
}

try {
  importAll(require.context('./strings', false, /\.json$/));
} catch (e) {
  // Fallback for environments where require.context is not available
}

const LocaleProvider = ({ locale, children }) => {
  const strings = allStrings[locale] || allStrings['en-GB'] || {};
  const fallback = allStrings['en-GB'] || {};

  const t = (key, params) => {
    let value = strings[key] || fallback[key] || key;
    if (params) {
      Object.keys(params).forEach(k => {
        value = value.replace(new RegExp(`%\\{${k}\\}`, 'g'), params[k]);
      });
    }
    return value;
  };

  return (
    <LocaleContext.Provider value={{ locale, t }}>
      {children}
    </LocaleContext.Provider>
  );
};

const useLocale = () => useContext(LocaleContext);

export { LocaleContext, LocaleProvider, useLocale };
export default LocaleContext;
